export const hoeffnerUrl: string = process.env.REACT_APP_SHOP ?? '';

// They don't have stagings, so no .env entry
export const mahlerUrl = 'https://www.moebel-mahler-siebenlehn.de';
export const kraftUrl = 'https://www.moebel-kraft.de';
